export default __webpack_public_path__ + "static/media/10.62bbcb92.webp";